import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function create(data) {
  const response = await http.postData("/resume-hemodialisa", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/resume-hemodialisa/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/resume-hemodialisa`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/resume-hemodialisa/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function sign(id: number, data) {
  const response = await http.postData(`/resume-hemodialisa/${id}/signature`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/resume-hemodialisa/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

function print(id) {
  window.open(`${http.getAPI()}/resume-hemodialisa/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  sign,
  destroy,
  print
};
